import { 
    ENTITY_FETCH_LIST_REQUEST, 
    ENTITY_FETCH_LIST_SUCCESS, 
    ENTITY_FETCH_LIST_FAILURE, 
    ENTITY_RESET_LIST 
  } from './entity.constants';
  
  // Initial state for the entity reducer
  const initialState = {
    loading: false,      // Indicates if a fetch request is in progress
    error: null,         // Holds any error message from a failed request
    entityList: [],      // Stores the list of entities returned from API
  };
  
  // Reducer function to manage entity-related state
  export const entityReducer = (state = initialState, action) => {
    switch (action.type) {
      
      // Triggered when a fetch request is initiated
      case ENTITY_FETCH_LIST_REQUEST:
        return {
          ...state,
          loading: true,     // Start loading spinner
          error: null,       // Clear previous errors
        };
  
      // Triggered when entity list fetch is successful
      case ENTITY_FETCH_LIST_SUCCESS:
        return {
          ...state,
          loading: false,              // Stop loading spinner
          entityList: action.payload,  // Update the list (can be empty or populated)
        };
  
      // Triggered when entity list fetch fails
      case ENTITY_FETCH_LIST_FAILURE:
        return {
          ...state,
          loading: false,       // Stop loading spinner
          error: action.payload // Store error message for display
        };
  
      // Resets entity state back to initial values
      case ENTITY_RESET_LIST:
        return initialState;
  
      // Return the unchanged state for any unrelated action
      default:
        return state;
    }
  };
  